export enum validationPattern{
    Number = "^[0-9\b]+$",
    Email = "^\\w+([.-]?\\w+)*@\\w+([.-]?\\w+)*(\\.\\w+)+$",
    PanCard = "^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$",
    Character = "^[A-Za-z \b]+$",
    AlphaNumeric = "^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$"
}